import React, { useState } from "react";
import { TelegramLink } from "../../common/TelegramLink";
import { AfishaDay } from "./afishaUtils";

type AfishaTrackProps = {
  event: AfishaDay["events"][number];
};

const LinkIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
    <path d="M6.354 5.5H4a3 3 0 0 0 0 6h3a3 3 0 0 0 2.83-4H9q-.13 0-.25.031A2 2 0 0 1 7 10.5H4a2 2 0 1 1 0-4h1.535c.218-.376.495-.714.82-1z" />
    <path d="M9 5.5a3 3 0 0 0-2.83 4h1.098A2 2 0 0 1 9 6.5h3a2 2 0 1 1 0 4h-1.535a4 4 0 0 1-.82 1H12a3 3 0 1 0 0-6z" />
  </svg>
);

const ExpandIcon = ({ expanded }: { expanded: boolean }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
    className={
      "afisha-track__expand-icon" +
      (expanded ? " afisha-track__expand-icon--open" : "")
    }
  >
    <path
      d="M4 6l4 4 4-4"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AfishaTrack = ({ event }: AfishaTrackProps) => {
  const [expanded, setExpanded] = useState(false);
  const hasBody = Boolean(event.body);

  const toggleExpanded = () => {
    if (!hasBody) return;
    setExpanded((open) => !open);
  };

  return (
    <article
      className={
        "afisha-track" + (expanded ? " afisha-track--expanded" : "")
      }
    >
      <div className="afisha-track__row">
        <div className="afisha-track__time-wrap">
          <span className="afisha-track__time">{event.time}</span>
          {event.tag_diff != null && (
            <span
              className="afisha-track__tag-diff"
              title="Расстояние до категории (tag_diff)"
            >
              {event.tag_diff.toFixed(3)}
            </span>
          )}
        </div>
        {hasBody ? (
          <button
            type="button"
            className="afisha-track__title afisha-track__title--link"
            aria-expanded={expanded}
            onClick={toggleExpanded}
          >
            {event.title}
          </button>
        ) : (
          <span className="afisha-track__title">{event.title}</span>
        )}

        <div className="afisha-track__actions">
          {hasBody && (
            <button
              type="button"
              className="afisha-track__more"
              aria-expanded={expanded}
              aria-label={expanded ? "Скрыть описание" : "Подробнее"}
              title={expanded ? "Скрыть" : "Подробнее"}
              onClick={toggleExpanded}
            >
              <span className="afisha-track__more-text">
                {expanded ? "Скрыть" : "Подробнее"}
              </span>
              <span className="afisha-track__more-icon">
                <ExpandIcon expanded={expanded} />
              </span>
            </button>
          )}

          {event.tgUrl && (
            <TelegramLink
              className="afisha-track__open-btn"
              href={event.tgUrl}
              aria-label="Открыть пост в источнике"
              title="Открыть пост"
            >
              <LinkIcon />
            </TelegramLink>
          )}
        </div>
      </div>

      {hasBody && (
        <div
          className={
            "afisha-track__body" +
            (expanded ? " afisha-track__body--open" : "")
          }
        >
          <div className="afisha-track__body-inner">
            <div className="afisha-track__body-text">{event.body}</div>
            {expanded && event.tgUrl && (
              <TelegramLink
                className="afisha-track__source-link"
                href={event.tgUrl}
              >
                Открыть в источнике
              </TelegramLink>
            )}
          </div>
        </div>
      )}
    </article>
  );
};
